import { defineResolver } from 'customer-flows/utils/quote/resolvers'

export default {
  channelId: defineResolver<string | undefined>(({ resolveStoreProp }) => ({
    resolve: () => resolveStoreProp('application', 'channelId')
  }))
}
